module.exports = __webpack_public_path__ + "static/media/config-icon.16f96b74.svg";